import { CheckCircle, Circle } from "@mui/icons-material";
import { formatTime } from "../../../../helper/converters";

const TableParticipants = (props: any) => {
  const { participants } = props;
  return (
    <div
      className={`participant-table ${participants.title ? "full-width" : ""}`}
    >
      <div className="participant-table-header">{participants.name}</div>
      <div className="participant-table-border">
        <div className="participant-table-header-columns">
          <div>Name</div>
          <div>CALL TIME</div>
        </div>
        {participants.users.map((person: any) => (
          <div
            key={person.id}
            className="participant-table-body"
          >
            <div>
              <span className="table-icon">
                {person.approved_call_sheet ? (
                  <CheckCircle className="enable" />
                ) : (
                  <Circle />
                )}
              </span>
              {person.full_name}
              <span>{person.job_title.name}</span>
            </div>
            <div>
              {person.time_call_sheet ? formatTime(person.time_call_sheet) : ""}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableParticipants;
